<script setup lang="ts">
import { appUrl } from '../config/runtime-config';

/**
 * Barra appiccicata: marchio a sinistra, indice al centro, ingresso all'app a
 * destra. L'altezza è `--header-height`, lo stesso token che `scroll-padding-top`
 * usa per non far finire i titoli sotto la barra quando si clicca un'ancora.
 *
 * Sul telefono l'indice sparisce e resta il solo pulsante: tre voci di menu
 * strette una accanto all'altra si sbagliano a colpire, e la pagina si scorre
 * comunque in dieci secondi.
 *
 * Le ancore sono assolute (`/#cosa-fa`, non `#cosa-fa`) perché questa barra sta
 * anche in cima alle pagine legali, dove quelle sezioni non esistono: un'ancora
 * relativa lì non porterebbe da nessuna parte.
 */
</script>

<template>
  <header class="bar">
    <a class="bar__brand" href="/#top">
      <img src="/brand/logo.svg" width="126" height="36" alt="Falasta" />
    </a>

    <nav class="bar__nav" aria-label="Sezioni della pagina">
      <a href="/#cosa-fa">Cosa fa</a>
      <a href="/#come-funziona">Come funziona</a>
      <a href="/#domande">Domande</a>
    </nav>

    <a class="button button--sm" :href="appUrl">Entra</a>
  </header>
</template>

<style scoped>
.bar {
  position: sticky;
  top: 0;
  z-index: 30;
  height: var(--header-height);
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 clamp(0.75rem, 3vw, 1.5rem);
  background: color-mix(in srgb, var(--color-bg) 88%, transparent);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--color-border);
}

.bar__brand {
  display: flex;
  align-items: center;
  margin-right: auto;
}

.bar__brand img {
  display: block;
  height: 1.75rem;
  width: auto;
}

.bar__nav {
  display: none;
  gap: 1.5rem;
  font-size: 0.9375rem;
}

.bar__nav a {
  color: var(--color-muted);
  text-decoration: none;
}

.bar__nav a:hover {
  color: var(--color-heading);
}

@media (min-width: 48rem) {
  .bar__nav {
    display: flex;
  }

  .bar {
    gap: 2rem;
  }
}
</style>
